import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/tick.png';
const _withScopeId = n => (_pushScopeId("data-v-030aad66"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "addAdressPage" };
const _hoisted_2 = { class: "addressBox" };
const _hoisted_3 = { class: "flex-align-center" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "ticketName" }, "收票人", -1));
const _hoisted_5 = { class: "flex-align-center" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "ticketName" }, "联系电话", -1));
const _hoisted_7 = { class: "flex-align-center" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "ticketName" }, "所在区域", -1));
const _hoisted_9 = { class: "flex-align-center" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "ticketName" }, "详细地址", -1));
const _hoisted_11 = { class: "defaultAddress flex-align-center" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "ticketName" }, "设为默认地址 ", -1));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "bottomBtn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        class: "submitInput",
        type: "submit"
    }, "保存")
], -1));
import { addressDeatil } from '@/api/invoice';
import Header from '@/components/common/Header.vue';
import { appPort, closeWebView } from '@/widget/index';
import { ref, onMounted, reactive } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const isApp = ref(appPort());
        const addressId = ref(0);
        const name = ref('');
        const formData = reactive({
            userName: '',
            phone: '',
            addressConcat: '',
            addressDetail: '',
            isDefault: false
        });
        const detailData = ref([{}]);
        const backFn = () => {
            if (isApp.value) {
                closeWebView();
            }
            else {
                history.go(-1);
            }
        };
        const getData = () => {
            addressDeatil({
                addressId: 5630
            }).then((res) => {
                if (res.code === 200) {
                    formData.userName = res.data.userName;
                    formData.phone = res.data.phone;
                    formData.addressConcat = res.data.addressConcat;
                    formData.addressDetail = res.data.addressDetail;
                    formData.isDefault = res.data.isDefault;
                }
            });
        };
        onMounted(() => {
            getData();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header, {
                    onBackFn: backFn,
                    showBack: true,
                    isColor: true,
                    pageTitle: '添加地址'
                }),
                _createElementVNode("ul", _hoisted_2, [
                    _createElementVNode("li", _hoisted_3, [
                        _hoisted_4,
                        _withDirectives(_createElementVNode("input", {
                            id: "tax-number",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(formData).userName) = $event)),
                            placeholder: "请输入收票人姓名",
                            required: ""
                        }, null, 512), [
                            [_vModelText, _unref(formData).userName]
                        ])
                    ]),
                    _createElementVNode("li", _hoisted_5, [
                        _hoisted_6,
                        _withDirectives(_createElementVNode("input", {
                            id: "tax-number",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(formData).phone) = $event)),
                            placeholder: "请输入联系电话",
                            required: ""
                        }, null, 512), [
                            [_vModelText, _unref(formData).phone]
                        ])
                    ]),
                    _createElementVNode("li", _hoisted_7, [
                        _hoisted_8,
                        _withDirectives(_createElementVNode("input", {
                            id: "tax-number",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(formData).addressConcat) = $event)),
                            placeholder: "选择省市区",
                            required: ""
                        }, null, 512), [
                            [_vModelText, _unref(formData).addressConcat]
                        ])
                    ]),
                    _createElementVNode("li", _hoisted_9, [
                        _hoisted_10,
                        _withDirectives(_createElementVNode("input", {
                            id: "tax-number",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(formData).addressDetail) = $event)),
                            placeholder: "请输入详细地址",
                            required: ""
                        }, null, 512), [
                            [_vModelText, _unref(formData).addressDetail]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", {
                        class: _normalizeClass(["checkmark", { active: _unref(formData).isDefault }])
                    }, _hoisted_14, 2)
                ]),
                _hoisted_15
            ]));
        };
    }
});
